module.exports = __webpack_public_path__ + "static/media/tuna.fbd6ecf5.png";